module.exports = __webpack_public_path__ + "static/media/16a-05_Camouflage1-2016-1524x3048mm-oleo-sobre-madera.06dd4e5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16a/16a-05_Camouflage1-2016-1524x3048mm-oleo-sobre-madera.jpg
// module id = 187
// module chunks = 0